import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { isAdminAuthenticated, logout } from '../../utils/adminAuth';

const AnalyticsSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAdmin = isAdminAuthenticated();

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    {
      id: 1,
      title: 'Overview',
      link: isAdmin ? '/admin' : '/analytics',
      exact: true,
      icon: 'ti-layout-grid2'
    },
    {
      id: 2,
      title: 'Analytics',
      link: isAdmin ? '/admin/analytics' : '/analytics/analytics',
      icon: 'ti-bar-chart'
    },
    {
      id: 3,
      title: 'Reports',
      link: isAdmin ? '/admin/reports' : '/analytics/reports',
      icon: 'ti-file'
    },
    {
      id: 4,
      title: 'Landing Page',
      link: isAdmin ? '/admin/landing-page' : '/analytics/landing-page',
      icon: 'ti-world'
    },
    {
      id: 5,
      title: 'Bookings',
      link: isAdmin ? '/admin/bookings' : '/analytics/bookings',
      icon: 'ti-receipt'
    }
  ];

  return (
    <div className="col-lg-2 col-md-4 analytics-sidebar-full">
      <div className="single-sidebar analytics-sidebar-inner">
        <div className="service-widget widget analytics-menu-widget">
          <h2>Analytics Menu</h2>
          <ul>
            {menuItems.map((item) => {
              return (
                <li key={item.id}>
                  <NavLink
                    onClick={ClickHandler}
                    to={item.link}
                    end={item.exact || false}
                    className={({ isActive }) => isActive ? 'active' : ''}
                  >
                    <i className={item.icon}></i>
                    <span>{item.title}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
          
          {isAdmin && (
            <div className="analytics-logout-wrapper">
              <button
                className="analytics-logout-btn"
                onClick={handleLogout}
              >
                <i className="ti-power-off"></i>
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsSidebar;

